import type { PagedResultRequestDto } from '@abp/ng.core';

export interface DefaultSommelierDto {
  slug?: string | null;
}

export interface SlugCheckResultDto {
  exists: boolean;
  isActive: boolean;
}

export interface SommelierPublicDto {
  id: number;
  slug?: string;
  name?: string;
  surname?: string;
  fileAttachmentId?: number;
  profileImageUrl?: string;
  bio?: string;
  country?: string;
  region?: string;
  city?: string;
  specialities?: string;
  certification?: string;
  phone?: string;
  commissionRate: number;
}

export interface SearchSommeliersDto extends PagedResultRequestDto {
  province?: string;
  locality?: string;
  keyword?: string;
}
